import { useState, useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Link, useParams, useNavigate } from "react-router-dom";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// ==================== COMPONENTS ====================

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <header className="bg-gradient-to-r from-purple-900 via-purple-800 to-indigo-900 sticky top-0 z-50 shadow-lg">
      <nav className="container mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          <Link to="/" className="flex items-center space-x-2" data-testid="logo-link">
            <span className="text-3xl">🎮</span>
            <span className="text-2xl font-bold text-white">Dicas de Games</span>
          </Link>
          
          {/* Desktop Menu */}
          <div className="hidden md:flex items-center space-x-6">
            <Link to="/" className="text-white hover:text-purple-300 transition" data-testid="nav-home">Home</Link>
            <Link to="/jogos/roblox" className="text-white hover:text-purple-300 transition" data-testid="nav-roblox">Roblox</Link>
            <Link to="/jogos/fortnite" className="text-white hover:text-purple-300 transition" data-testid="nav-fortnite">Fortnite</Link>
            <Link to="/jogos/freefire" className="text-white hover:text-purple-300 transition" data-testid="nav-freefire">Free Fire</Link>
            <Link to="/jogos/minecraft" className="text-white hover:text-purple-300 transition" data-testid="nav-minecraft">Minecraft</Link>
            <Link to="/loja" className="text-white hover:text-purple-300 transition" data-testid="nav-loja">Loja</Link>
            <Link to="/sobre" className="text-white hover:text-purple-300 transition" data-testid="nav-sobre">Sobre</Link>
            <Link to="/contato" className="text-white hover:text-purple-300 transition" data-testid="nav-contato">Contato</Link>
          </div>

          {/* Mobile Menu Button */}
          <button 
            className="md:hidden text-white p-2"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            data-testid="mobile-menu-btn"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="md:hidden mt-4 pb-4 space-y-3" data-testid="mobile-menu">
            <Link to="/" className="block text-white hover:text-purple-300 py-2">Home</Link>
            <Link to="/jogos/roblox" className="block text-white hover:text-purple-300 py-2">Roblox</Link>
            <Link to="/jogos/fortnite" className="block text-white hover:text-purple-300 py-2">Fortnite</Link>
            <Link to="/jogos/freefire" className="block text-white hover:text-purple-300 py-2">Free Fire</Link>
            <Link to="/jogos/minecraft" className="block text-white hover:text-purple-300 py-2">Minecraft</Link>
            <Link to="/loja" className="block text-white hover:text-purple-300 py-2">Loja</Link>
            <Link to="/sobre" className="block text-white hover:text-purple-300 py-2">Sobre</Link>
            <Link to="/contato" className="block text-white hover:text-purple-300 py-2">Contato</Link>
          </div>
        )}
      </nav>
    </header>
  );
};

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid md:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center space-x-2 mb-4">
              <span className="text-3xl">🎮</span>
              <span className="text-xl font-bold">Dicas de Games</span>
            </div>
            <p className="text-gray-400">Seu portal de dicas, guias e novidades do mundo gamer.</p>
          </div>
          
          <div>
            <h4 className="font-bold mb-4 text-purple-400">Jogos</h4>
            <ul className="space-y-2 text-gray-400">
              <li><Link to="/jogos/roblox" className="hover:text-white transition">Roblox</Link></li>
              <li><Link to="/jogos/fortnite" className="hover:text-white transition">Fortnite</Link></li>
              <li><Link to="/jogos/freefire" className="hover:text-white transition">Free Fire</Link></li>
              <li><Link to="/jogos/minecraft" className="hover:text-white transition">Minecraft</Link></li>
            </ul>
          </div>
          
          <div>
            <h4 className="font-bold mb-4 text-purple-400">Links Úteis</h4>
            <ul className="space-y-2 text-gray-400">
              <li><Link to="/sobre" className="hover:text-white transition">Sobre</Link></li>
              <li><Link to="/contato" className="hover:text-white transition">Contato</Link></li>
              <li><Link to="/politica-de-privacidade" className="hover:text-white transition">Política de Privacidade</Link></li>
              <li><Link to="/termos-de-uso" className="hover:text-white transition">Termos de Uso</Link></li>
            </ul>
          </div>
          
          <div>
            <h4 className="font-bold mb-4 text-purple-400">Newsletter</h4>
            <p className="text-gray-400 mb-4">Receba as melhores dicas no seu email!</p>
            <NewsletterForm />
          </div>
        </div>
        
        <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-500">
          <p>© 2025 Dicas de Games. Todos os direitos reservados.</p>
          <p className="text-sm mt-2">dicasdegames.site</p>
        </div>
      </div>
    </footer>
  );
};

const NewsletterForm = () => {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${API}/newsletter`, { email });
      setStatus("success");
      setEmail("");
    } catch (error) {
      if (error.response?.status === 400) {
        setStatus("exists");
      } else {
        setStatus("error");
      }
    }
  };

  return (
    <form onSubmit={handleSubmit} className="flex flex-col gap-2" data-testid="newsletter-form">
      <input
        type="email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="Seu email"
        className="px-4 py-2 rounded bg-gray-800 text-white border border-gray-700 focus:border-purple-500 focus:outline-none"
        required
        data-testid="newsletter-input"
      />
      <button
        type="submit"
        className="bg-purple-600 hover:bg-purple-700 text-white px-4 py-2 rounded transition"
        data-testid="newsletter-btn"
      >
        Inscrever
      </button>
      {status === "success" && <p className="text-green-400 text-sm">Inscrito com sucesso!</p>}
      {status === "exists" && <p className="text-yellow-400 text-sm">Email já cadastrado!</p>}
      {status === "error" && <p className="text-red-400 text-sm">Erro ao inscrever.</p>}
    </form>
  );
};

const PostCard = ({ post }) => {
  const gameColors = {
    roblox: "bg-red-500",
    fortnite: "bg-blue-500",
    freefire: "bg-orange-500",
    minecraft: "bg-green-500",
  };

  return (
    <Link to={`/post/${post.slug}`} className="group" data-testid={`post-card-${post.slug}`}>
      <div className="bg-gray-800 rounded-xl overflow-hidden shadow-lg hover:shadow-purple-500/20 transition-all duration-300 hover:-translate-y-1">
        <div className="relative h-48 overflow-hidden">
          <img
            src={post.image_url}
            alt={post.title}
            className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
          />
          <div className="absolute top-3 left-3 flex gap-2">
            {post.game && (
              <span className={`${gameColors[post.game] || 'bg-purple-500'} text-white text-xs px-2 py-1 rounded-full uppercase font-semibold`}>
                {post.game}
              </span>
            )}
            <span className="bg-gray-900/80 text-white text-xs px-2 py-1 rounded-full">
              {post.category}
            </span>
          </div>
        </div>
        <div className="p-5">
          <h3 className="text-white font-bold text-lg mb-2 group-hover:text-purple-400 transition">
            {post.title}
          </h3>
          <p className="text-gray-400 text-sm line-clamp-2">{post.excerpt}</p>
          <div className="mt-4 flex items-center justify-between text-xs text-gray-500">
            <span>👁 {post.views} views</span>
            <span className="text-purple-400 group-hover:text-purple-300">Ler mais →</span>
          </div>
        </div>
      </div>
    </Link>
  );
};

const ProductCard = ({ product }) => {
  return (
    <div className="bg-gray-800 rounded-xl overflow-hidden shadow-lg hover:shadow-purple-500/20 transition-all duration-300" data-testid={`product-card-${product.id}`}>
      <div className="relative h-48 overflow-hidden">
        <img
          src={product.image_url}
          alt={product.name}
          className="w-full h-full object-cover"
        />
        {product.featured && (
          <span className="absolute top-3 right-3 bg-yellow-500 text-black text-xs px-2 py-1 rounded-full font-semibold">
            ⭐ Destaque
          </span>
        )}
      </div>
      <div className="p-5">
        <h3 className="text-white font-bold text-lg mb-2 line-clamp-2">{product.name}</h3>
        <p className="text-gray-400 text-sm mb-3 line-clamp-2">{product.description}</p>
        <div className="flex items-center justify-between">
          <span className="text-2xl font-bold text-green-400">{product.price}</span>
          <a
            href={product.affiliate_link}
            target="_blank"
            rel="noopener noreferrer"
            className="bg-orange-500 hover:bg-orange-600 text-white px-4 py-2 rounded-lg transition font-semibold"
            data-testid={`buy-btn-${product.id}`}
          >
            Comprar
          </a>
        </div>
      </div>
    </div>
  );
};

// ==================== PAGES ====================

const HomePage = () => {
  const [posts, setPosts] = useState([]);
  const [featuredProducts, setFeaturedProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Seed data first
        await axios.post(`${API}/seed`);
        
        const [postsRes, productsRes] = await Promise.all([
          axios.get(`${API}/posts`),
          axios.get(`${API}/products?featured=true`)
        ]);
        setPosts(postsRes.data);
        setFeaturedProducts(productsRes.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-900 flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-purple-500"></div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-900">
      {/* Hero Section */}
      <section className="relative py-20 overflow-hidden" data-testid="hero-section">
        <div className="absolute inset-0 bg-gradient-to-br from-purple-900/50 via-gray-900 to-indigo-900/50"></div>
        <div className="container mx-auto px-4 relative z-10">
          <div className="text-center max-w-4xl mx-auto">
            <h1 className="text-5xl md:text-6xl font-bold text-white mb-6">
              Bem-vindo ao <span className="text-transparent bg-clip-text bg-gradient-to-r from-purple-400 to-pink-400">Dicas de Games</span>
            </h1>
            <p className="text-xl text-gray-300 mb-8">
              Seu portal completo de dicas, guias, atualizações e reviews dos melhores jogos!
            </p>
            <div className="flex flex-wrap justify-center gap-4">
              <Link to="/jogos/roblox" className="bg-red-500 hover:bg-red-600 text-white px-6 py-3 rounded-lg font-semibold transition">🎮 Roblox</Link>
              <Link to="/jogos/fortnite" className="bg-blue-500 hover:bg-blue-600 text-white px-6 py-3 rounded-lg font-semibold transition">🎯 Fortnite</Link>
              <Link to="/jogos/freefire" className="bg-orange-500 hover:bg-orange-600 text-white px-6 py-3 rounded-lg font-semibold transition">🔥 Free Fire</Link>
              <Link to="/jogos/minecraft" className="bg-green-500 hover:bg-green-600 text-white px-6 py-3 rounded-lg font-semibold transition">⛏️ Minecraft</Link>
            </div>
          </div>
        </div>
      </section>

      {/* Featured Posts */}
      <section className="py-16 container mx-auto px-4">
        <h2 className="text-3xl font-bold text-white mb-8 flex items-center gap-3">
          <span className="text-purple-400">🔥</span> Posts em Destaque
        </h2>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {posts.slice(0, 6).map((post) => (
            <PostCard key={post.id} post={post} />
          ))}
        </div>
      </section>

      {/* Products Section */}
      <section className="py-16 bg-gray-800/50">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-white mb-8 flex items-center gap-3">
            <span className="text-yellow-400">🛒</span> Produtos em Destaque
          </h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {featuredProducts.map((product) => (
              <ProductCard key={product.id} product={product} />
            ))}
          </div>
          <div className="text-center mt-8">
            <Link to="/loja" className="inline-block bg-purple-600 hover:bg-purple-700 text-white px-8 py-3 rounded-lg font-semibold transition" data-testid="ver-todos-produtos">
              Ver Todos os Produtos
            </Link>
          </div>
        </div>
      </section>

      {/* All Posts */}
      <section className="py-16 container mx-auto px-4">
        <h2 className="text-3xl font-bold text-white mb-8 flex items-center gap-3">
          <span className="text-blue-400">📝</span> Todos os Posts
        </h2>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {posts.map((post) => (
            <PostCard key={post.id} post={post} />
          ))}
        </div>
      </section>
    </div>
  );
};

const GamePage = () => {
  const { game } = useParams();
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  const gameInfo = {
    roblox: {
      name: "Roblox",
      emoji: "🎮",
      color: "from-red-600 to-red-800",
      description: "Dicas, guias e novidades sobre o universo Roblox. Domine seus jogos favoritos!"
    },
    fortnite: {
      name: "Fortnite",
      emoji: "🎯",
      color: "from-blue-600 to-blue-800",
      description: "Estratégias, atualizações e dicas para conseguir mais Victory Royales!"
    },
    freefire: {
      name: "Free Fire",
      emoji: "🔥",
      color: "from-orange-600 to-orange-800",
      description: "Tudo sobre Free Fire: personagens, armas, mapas e dicas para subir de rank!"
    },
    minecraft: {
      name: "Minecraft",
      emoji: "⛏️",
      color: "from-green-600 to-green-800",
      description: "Guias de sobrevivência, construções épicas e dicas para minerar diamantes!"
    }
  };

  const info = gameInfo[game] || { name: game, emoji: "🎮", color: "from-purple-600 to-purple-800", description: "" };

  useEffect(() => {
    const fetchPosts = async () => {
      try {
        const response = await axios.get(`${API}/posts?game=${game}`);
        setPosts(response.data);
      } catch (error) {
        console.error("Error fetching posts:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchPosts();
  }, [game]);

  return (
    <div className="min-h-screen bg-gray-900">
      {/* Hero */}
      <section className={`py-16 bg-gradient-to-r ${info.color}`} data-testid={`game-hero-${game}`}>
        <div className="container mx-auto px-4 text-center">
          <span className="text-6xl mb-4 block">{info.emoji}</span>
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">{info.name}</h1>
          <p className="text-xl text-white/80 max-w-2xl mx-auto">{info.description}</p>
        </div>
      </section>

      {/* Posts */}
      <section className="py-16 container mx-auto px-4">
        {loading ? (
          <div className="flex justify-center">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-purple-500"></div>
          </div>
        ) : posts.length > 0 ? (
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {posts.map((post) => (
              <PostCard key={post.id} post={post} />
            ))}
          </div>
        ) : (
          <p className="text-center text-gray-400 text-xl">Nenhum post encontrado para {info.name}.</p>
        )}
      </section>
    </div>
  );
};

const PostPage = () => {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [relatedPosts, setRelatedPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPost = async () => {
      try {
        const response = await axios.get(`${API}/posts/${slug}`);
        setPost(response.data);
        
        // Fetch related posts
        if (response.data.game) {
          const relatedRes = await axios.get(`${API}/posts?game=${response.data.game}&limit=3`);
          setRelatedPosts(relatedRes.data.filter(p => p.slug !== slug).slice(0, 3));
        }
      } catch (error) {
        console.error("Error fetching post:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchPost();
  }, [slug]);

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-900 flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-purple-500"></div>
      </div>
    );
  }

  if (!post) {
    return (
      <div className="min-h-screen bg-gray-900 flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-4xl font-bold text-white mb-4">Post não encontrado</h1>
          <Link to="/" className="text-purple-400 hover:text-purple-300">← Voltar para Home</Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-900">
      {/* Hero Image */}
      <div className="relative h-64 md:h-96">
        <img src={post.image_url} alt={post.title} className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-gray-900 via-gray-900/50 to-transparent"></div>
      </div>

      <article className="container mx-auto px-4 py-12 max-w-4xl -mt-32 relative z-10" data-testid={`post-${slug}`}>
        <div className="bg-gray-800 rounded-2xl p-8 md:p-12 shadow-2xl">
          {/* Tags */}
          <div className="flex flex-wrap gap-2 mb-4">
            {post.game && (
              <span className="bg-purple-600 text-white text-sm px-3 py-1 rounded-full">{post.game}</span>
            )}
            <span className="bg-gray-700 text-gray-300 text-sm px-3 py-1 rounded-full">{post.category}</span>
          </div>

          {/* Title */}
          <h1 className="text-3xl md:text-4xl font-bold text-white mb-6">{post.title}</h1>

          {/* Meta */}
          <div className="flex items-center gap-4 text-gray-400 text-sm mb-8 pb-8 border-b border-gray-700">
            <span>👁 {post.views} visualizações</span>
            <span>📅 {new Date(post.created_at).toLocaleDateString('pt-BR')}</span>
          </div>

          {/* Content */}
          <div 
            className="prose prose-invert prose-lg max-w-none
              prose-headings:text-purple-400 prose-headings:font-bold
              prose-h2:text-2xl prose-h2:mt-8 prose-h2:mb-4
              prose-h3:text-xl prose-h3:mt-6 prose-h3:mb-3
              prose-p:text-gray-300 prose-p:leading-relaxed
              prose-ul:text-gray-300 prose-ol:text-gray-300
              prose-li:mb-2
              prose-strong:text-white"
            dangerouslySetInnerHTML={{ __html: post.content }}
          />

          {/* Tags */}
          <div className="mt-12 pt-8 border-t border-gray-700">
            <h4 className="text-gray-400 mb-3">Tags:</h4>
            <div className="flex flex-wrap gap-2">
              {post.tags.map((tag, idx) => (
                <span key={idx} className="bg-gray-700 text-gray-300 text-sm px-3 py-1 rounded-full">#{tag}</span>
              ))}
            </div>
          </div>
        </div>

        {/* Related Posts */}
        {relatedPosts.length > 0 && (
          <div className="mt-12">
            <h2 className="text-2xl font-bold text-white mb-6">Posts Relacionados</h2>
            <div className="grid md:grid-cols-3 gap-6">
              {relatedPosts.map((relPost) => (
                <PostCard key={relPost.id} post={relPost} />
              ))}
            </div>
          </div>
        )}
      </article>
    </div>
  );
};

const LojaPage = () => {
  const [products, setProducts] = useState([]);
  const [category, setCategory] = useState("");
  const [loading, setLoading] = useState(true);

  const categories = [
    { value: "", label: "Todos" },
    { value: "controles", label: "Controles" },
    { value: "headsets", label: "Headsets" },
    { value: "teclados", label: "Teclados" },
    { value: "consoles", label: "Consoles" },
    { value: "acessorios", label: "Acessórios" }
  ];

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const url = category ? `${API}/products?category=${category}` : `${API}/products`;
        const response = await axios.get(url);
        setProducts(response.data);
      } catch (error) {
        console.error("Error fetching products:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchProducts();
  }, [category]);

  return (
    <div className="min-h-screen bg-gray-900">
      {/* Hero */}
      <section className="py-16 bg-gradient-to-r from-orange-600 to-red-600" data-testid="loja-hero">
        <div className="container mx-auto px-4 text-center">
          <span className="text-6xl mb-4 block">🛒</span>
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">Loja Gamer</h1>
          <p className="text-xl text-white/80 max-w-2xl mx-auto">Os melhores produtos para gamers com preços incríveis!</p>
        </div>
      </section>

      {/* Filters */}
      <section className="py-8 bg-gray-800">
        <div className="container mx-auto px-4">
          <div className="flex flex-wrap gap-3 justify-center">
            {categories.map((cat) => (
              <button
                key={cat.value}
                onClick={() => setCategory(cat.value)}
                className={`px-4 py-2 rounded-lg font-semibold transition ${
                  category === cat.value
                    ? "bg-purple-600 text-white"
                    : "bg-gray-700 text-gray-300 hover:bg-gray-600"
                }`}
                data-testid={`filter-${cat.value || 'all'}`}
              >
                {cat.label}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Products */}
      <section className="py-16 container mx-auto px-4">
        {loading ? (
          <div className="flex justify-center">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-purple-500"></div>
          </div>
        ) : (
          <div className="grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
            {products.map((product) => (
              <ProductCard key={product.id} product={product} />
            ))}
          </div>
        )}
      </section>

      {/* Affiliate Disclaimer */}
      <section className="py-8 bg-gray-800/50">
        <div className="container mx-auto px-4 text-center text-gray-400 text-sm">
          <p>⚠️ Links de afiliados: ao comprar através dos nossos links, você nos ajuda a manter o site sem custo adicional para você.</p>
        </div>
      </section>
    </div>
  );
};

const SobrePage = () => {
  return (
    <div className="min-h-screen bg-gray-900" data-testid="sobre-page">
      <section className="py-16 bg-gradient-to-r from-purple-600 to-indigo-600">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">Sobre Nós</h1>
          <p className="text-xl text-white/80">Conheça o Dicas de Games</p>
        </div>
      </section>

      <section className="py-16 container mx-auto px-4 max-w-4xl">
        <div className="bg-gray-800 rounded-2xl p-8 md:p-12">
          <h2 className="text-2xl font-bold text-purple-400 mb-6">Quem Somos</h2>
          <p className="text-gray-300 mb-6 leading-relaxed">
            O Dicas de Games nasceu da paixão por jogos e da vontade de ajudar outros gamers a melhorarem suas habilidades e se divertirem ainda mais.
          </p>
          
          <h2 className="text-2xl font-bold text-purple-400 mb-6 mt-10">Nossa Missão</h2>
          <p className="text-gray-300 mb-6 leading-relaxed">
            Criar conteúdo de qualidade, com dicas práticas, guias completos e análises honestas para ajudar gamers de todos os níveis a aproveitarem ao máximo seus jogos favoritos.
          </p>

          <h2 className="text-2xl font-bold text-purple-400 mb-6 mt-10">O que Oferecemos</h2>
          <ul className="text-gray-300 space-y-3">
            <li className="flex items-start gap-3">
              <span className="text-green-400">✓</span>
              <span>Dicas e guias para Roblox, Fortnite, Free Fire, Minecraft e mais</span>
            </li>
            <li className="flex items-start gap-3">
              <span className="text-green-400">✓</span>
              <span>Atualizações sobre as novidades dos jogos</span>
            </li>
            <li className="flex items-start gap-3">
              <span className="text-green-400">✓</span>
              <span>Reviews de equipamentos gamer</span>
            </li>
            <li className="flex items-start gap-3">
              <span className="text-green-400">✓</span>
              <span>Listas dos melhores jogos grátis</span>
            </li>
            <li className="flex items-start gap-3">
              <span className="text-green-400">✓</span>
              <span>Ofertas e promoções de produtos gamer</span>
            </li>
          </ul>

          <div className="mt-12 text-center">
            <p className="text-gray-400">🎮 Bons jogos!</p>
            <p className="text-purple-400 font-bold mt-2">Equipe Dicas de Games</p>
          </div>
        </div>
      </section>
    </div>
  );
};

const ContatoPage = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: ""
  });
  const [status, setStatus] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${API}/contact`, formData);
      setStatus("success");
      setFormData({ name: "", email: "", subject: "", message: "" });
    } catch (error) {
      setStatus("error");
    }
  };

  return (
    <div className="min-h-screen bg-gray-900" data-testid="contato-page">
      <section className="py-16 bg-gradient-to-r from-green-600 to-teal-600">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">Contato</h1>
          <p className="text-xl text-white/80">Fale conosco!</p>
        </div>
      </section>

      <section className="py-16 container mx-auto px-4 max-w-2xl">
        <div className="bg-gray-800 rounded-2xl p-8 md:p-12">
          <form onSubmit={handleSubmit} className="space-y-6" data-testid="contact-form">
            <div>
              <label className="block text-gray-300 mb-2">Nome</label>
              <input
                type="text"
                value={formData.name}
                onChange={(e) => setFormData({...formData, name: e.target.value})}
                className="w-full px-4 py-3 rounded-lg bg-gray-700 text-white border border-gray-600 focus:border-purple-500 focus:outline-none"
                required
                data-testid="contact-name"
              />
            </div>
            <div>
              <label className="block text-gray-300 mb-2">Email</label>
              <input
                type="email"
                value={formData.email}
                onChange={(e) => setFormData({...formData, email: e.target.value})}
                className="w-full px-4 py-3 rounded-lg bg-gray-700 text-white border border-gray-600 focus:border-purple-500 focus:outline-none"
                required
                data-testid="contact-email"
              />
            </div>
            <div>
              <label className="block text-gray-300 mb-2">Assunto</label>
              <input
                type="text"
                value={formData.subject}
                onChange={(e) => setFormData({...formData, subject: e.target.value})}
                className="w-full px-4 py-3 rounded-lg bg-gray-700 text-white border border-gray-600 focus:border-purple-500 focus:outline-none"
                required
                data-testid="contact-subject"
              />
            </div>
            <div>
              <label className="block text-gray-300 mb-2">Mensagem</label>
              <textarea
                value={formData.message}
                onChange={(e) => setFormData({...formData, message: e.target.value})}
                className="w-full px-4 py-3 rounded-lg bg-gray-700 text-white border border-gray-600 focus:border-purple-500 focus:outline-none h-40 resize-none"
                required
                data-testid="contact-message"
              ></textarea>
            </div>
            <button
              type="submit"
              className="w-full bg-purple-600 hover:bg-purple-700 text-white py-3 rounded-lg font-semibold transition"
              data-testid="contact-submit"
            >
              Enviar Mensagem
            </button>
            {status === "success" && <p className="text-green-400 text-center">Mensagem enviada com sucesso!</p>}
            {status === "error" && <p className="text-red-400 text-center">Erro ao enviar mensagem.</p>}
          </form>
        </div>
      </section>
    </div>
  );
};

const PoliticaPrivacidadePage = () => {
  return (
    <div className="min-h-screen bg-gray-900" data-testid="politica-page">
      <section className="py-16 bg-gradient-to-r from-gray-700 to-gray-800">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">Política de Privacidade</h1>
        </div>
      </section>

      <section className="py-16 container mx-auto px-4 max-w-4xl">
        <div className="bg-gray-800 rounded-2xl p-8 md:p-12 prose prose-invert max-w-none">
          <h2 className="text-purple-400">1. Informações Coletadas</h2>
          <p className="text-gray-300">Coletamos informações que você nos fornece diretamente, como nome e email quando se inscreve em nossa newsletter ou entra em contato conosco.</p>

          <h2 className="text-purple-400 mt-8">2. Uso das Informações</h2>
          <p className="text-gray-300">Utilizamos suas informações para:</p>
          <ul className="text-gray-300">
            <li>Enviar nossa newsletter com dicas de games</li>
            <li>Responder suas mensagens de contato</li>
            <li>Melhorar nosso conteúdo e serviços</li>
          </ul>

          <h2 className="text-purple-400 mt-8">3. Cookies</h2>
          <p className="text-gray-300">Utilizamos cookies para melhorar sua experiência no site e para análises de tráfego através de ferramentas como Google Analytics.</p>

          <h2 className="text-purple-400 mt-8">4. Links de Afiliados</h2>
          <p className="text-gray-300">Nosso site contém links de afiliados. Quando você clica nesses links e realiza uma compra, podemos receber uma comissão sem custo adicional para você.</p>

          <h2 className="text-purple-400 mt-8">5. Proteção de Dados</h2>
          <p className="text-gray-300">Implementamos medidas de segurança para proteger suas informações pessoais contra acesso não autorizado.</p>

          <h2 className="text-purple-400 mt-8">6. Contato</h2>
          <p className="text-gray-300">Para questões sobre esta política, entre em contato através da nossa página de contato.</p>

          <p className="text-gray-500 mt-8 text-sm">Última atualização: Agosto 2025</p>
        </div>
      </section>
    </div>
  );
};

const TermosUsoPage = () => {
  return (
    <div className="min-h-screen bg-gray-900" data-testid="termos-page">
      <section className="py-16 bg-gradient-to-r from-gray-700 to-gray-800">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">Termos de Uso</h1>
        </div>
      </section>

      <section className="py-16 container mx-auto px-4 max-w-4xl">
        <div className="bg-gray-800 rounded-2xl p-8 md:p-12 prose prose-invert max-w-none">
          <h2 className="text-purple-400">1. Aceitação dos Termos</h2>
          <p className="text-gray-300">Ao acessar e usar o site Dicas de Games, você concorda com estes termos de uso.</p>

          <h2 className="text-purple-400 mt-8">2. Uso do Conteúdo</h2>
          <p className="text-gray-300">Todo o conteúdo publicado neste site é protegido por direitos autorais. Você pode:</p>
          <ul className="text-gray-300">
            <li>Ler e compartilhar nossos artigos</li>
            <li>Usar as dicas para seu uso pessoal</li>
          </ul>
          <p className="text-gray-300">Você não pode:</p>
          <ul className="text-gray-300">
            <li>Copiar conteúdo para outros sites sem autorização</li>
            <li>Modificar ou distribuir nosso conteúdo</li>
          </ul>

          <h2 className="text-purple-400 mt-8">3. Precisão das Informações</h2>
          <p className="text-gray-300">Nos esforçamos para fornecer informações precisas, mas não garantimos a exatidão de todo o conteúdo. Dicas de jogos podem mudar com atualizações.</p>

          <h2 className="text-purple-400 mt-8">4. Links Externos</h2>
          <p className="text-gray-300">Nosso site contém links para sites externos e lojas. Não somos responsáveis pelo conteúdo ou práticas desses sites.</p>

          <h2 className="text-purple-400 mt-8">5. Produtos de Afiliados</h2>
          <p className="text-gray-300">Os produtos mostrados são de lojas parceiras. Não nos responsabilizamos por questões relacionadas a compras, entregas ou qualidade dos produtos.</p>

          <h2 className="text-purple-400 mt-8">6. Alterações</h2>
          <p className="text-gray-300">Reservamos o direito de modificar estes termos a qualquer momento. Alterações entram em vigor imediatamente após publicação.</p>

          <p className="text-gray-500 mt-8 text-sm">Última atualização: Agosto 2025</p>
        </div>
      </section>
    </div>
  );
};

// ==================== APP ====================

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Header />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/jogos/:game" element={<GamePage />} />
          <Route path="/post/:slug" element={<PostPage />} />
          <Route path="/loja" element={<LojaPage />} />
          <Route path="/sobre" element={<SobrePage />} />
          <Route path="/contato" element={<ContatoPage />} />
          <Route path="/politica-de-privacidade" element={<PoliticaPrivacidadePage />} />
          <Route path="/termos-de-uso" element={<TermosUsoPage />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
